import React, { useState, useEffect } from "react";
import { launch } from '../../functions/dexfunctions'
import { popupManager } from "../common/PopupManager";
import { useParams } from "react-router-dom";


const LaunchForm = ({signer}) => {
  const [token2, setToken2] = useState("");
  const [liquidity1, setLiquidity1] = useState("");
  const [liquidity2, setLiquidity2] = useState("");
  const [buyFeeAmount, setBuyFeeAmount] = useState("");
  const [sellFeeAmount, setSellFeeAmount] = useState("");
  const [protocolAddress, setProtocolAddress] = useState("");
  const [protocolBuyFee, setProtocolBuyFee] = useState("");
  const [protocolSellFee, setProtocolSellFee] = useState("");
  //const [showTokenSelector1, setShowTokenSelector1] = useState(false);
  const [showTokenSelector2, setShowTokenSelector2] = useState(false);

  // Transaction path for Launch page - always the same
  const getTransactionPath = () => {
    return [
      "1. Approve",
      "2. Launch"
    ];
  };

  const transactionPath = getTransactionPath();


    const {chain,tokenAddress } = useParams();
    const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
  const token1 = ethAddress;                        // locked forever

  //const [token1, setToken1] = useState(ethAddress); // Default to ETH


function chainParamToChainId(chainParam) {
  switch (chainParam) {
    case "ethereum":
      return 1;
    
    // add more if needed
    default:
      return null; // or 1 as a default
  }
}

useEffect(() => {
  /** Solana behavior removed */
  const fillDefault = async () => {
    // no-op
  };

  fillDefault();
}, [chain, signer, protocolAddress]);


useEffect(() => {
  if (!signer) return;

  const requiredChainId = chainParamToChainId(chain);

  // If we don't have a mapping, you might handle that differently
  if (!requiredChainId) return;

  (async () => {
    try {
      // Ethers.js v6 returns an object with .chainId
      const network = await signer.provider.getNetwork();
      const currentChainId = Number(network.chainId);

      if (currentChainId !== requiredChainId) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the selected network!",
          duration: 6000,
        });
      }
    } catch (err) {
      console.error("Error checking network:", err);
    }
  })();
}, [signer, chain]);
  const launchAttempt = async () => {
    let id = Date.now();
      try{
        const network = await signer.provider.getNetwork();
        const chainId = Number(network.chainId);
        //console.log(chainId);
        const requiredChainId = chainParamToChainId(chain);
        //console.log(chainId,requiredChainId)
        if (chainId !== requiredChainId) {
          popupManager.addPopup({
            id: Date.now(),
            type: "error",
            message: "Please connect your wallet to the selected network!",
            duration: 6000,
          });
          throw Error("Error")
        }
        popupManager.addPopup({
          id: id,
          type: "message",
          message: "Deploying Token...",
        });
        const response = await launch(token1,token2,liquidity1,liquidity2,
          "0", //min amounts
          "0", 
          signer,
            buyFeeAmount,sellFeeAmount,protocolBuyFee,protocolSellFee,protocolAddress,chain);
          //console.log(response)
            popupManager.removePopup(id);
            let successful_id = Date.now();
      
            popupManager.addPopup({
              id: successful_id,
              type: "success",
              message:
                "Transaction sent!",
            });

        //console.log(response)
      }catch(e){
        popupManager.removePopup(id);
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: e.toString(),
          duration: 6000,
        });
        console.log(e)
      }
    // Add your launch logic here
  };

  /*
  const validateAddress = (address) => {
    const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    return ethAddressRegex.test(address);
  };
  */

  const TokenSelectorPopup = ({ onClose, onSelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError]         = useState("");

  const validateAddress = (address, currentChain) => {
    const eth = /^0x[a-fA-F0-9]{40}$/;               // 42-char hex
    return eth.test(address);
  };


    useEffect(() => {
    if (validateAddress(inputValue, chain)) {        // pass `chain`
      onSelect(inputValue);
      onClose();
    } else if (inputValue.length > 0) {              // any non-empty entry
      setError(
        "Invalid Ethereum address. Must be 42 characters and start with 0x."
      );
    } else {
      setError("");
    }
  }, [inputValue, onClose, onSelect, chain]);   

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-[#0e1018] p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl mb-4 kanit-light font-[400] text-white">
          Paste Address
        </h2>

        <input
          type="text"
          placeholder="Enter or paste token address"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          maxLength={42}
          className="w-full p-2 mb-2 bg-transparent text-white kanit-light border border-white/20 rounded-md focus:outline-none"
        />

        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

        {/* Only the Cancel button remains */}
        <button
          onClick={onClose}
          className="w-full text-white bg-white/5 hover:bg-white/10 border border-white/10 py-2 rounded-md font-semibold transition duration-300"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};


const formatTokenDisplay = (token) => {
    if (token === ethAddress) {
      return "ETH";
    }

    const showShort =
      // EVM address
      token.length === 42 ||
      false;

    return showShort ? `${token.slice(0, 6)}...${token.slice(-4)}` : "Select";
};


  return (
    <div className="p-6 rounded-lg shadow-lg   max-w-lg mx-auto mt-20">
      <h1 className="text-3xl kanit-light font-[500] mb-4 text-center flex items-center mt-4">
        Deploy Token
        <div className="relative group ml-2 mb-4">
          <svg
            className="w-4 h-4 text-gray-400 cursor-pointer"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM9 7v2h2V7H9zm0 4v4h2v-4H9z" />
          </svg>
          <div
            className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-64 p-2 bg-[#0e1018] border border-white/15 text-white text-xs rounded-lg 
            hidden group-hover:block transition-opacity duration-200 font-[300] text-white"
          >
            Deploy a token by setting custom LP fees and Protocol fees for every buy and sell transaction, while specifying a protocol address that receives ETH from each swap.
          </div>
        </div>
      </h1>


      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          launchAttempt();
        }}
      >
        {/* Token 1 and Liquidity */}
        <div>
          <label className="block mb-3 text-start text-[14px] font-semibold text-gray-300">
            Liquidity
          </label>
          <div className="flex items-center w-full p-3 border-t border-b border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="number"
              value={liquidity1}
              onChange={(e) => setLiquidity1(e.target.value)}
              onWheel={e => e.target.blur()}
              className="bg-transparent flex-1   focus:outline-none h-6"
              placeholder="Enter Amount"
            />
            <button
              type="button"
              onClick={() => {}}
              className="flex items-center ml-2 focus:outline-none rounded-full  hover:bg-white/5 border border-white/15 px-3 py-1"
            >
              <span className="mr-1 text-[13px]">{formatTokenDisplay(token1)}</span>
              <svg
                className="w-4 h-4  "
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Token 2 and Liquidity */}
        <div>
          <div className="flex items-center w-full p-3 border-t border-b border-white/15  text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="number"
              value={liquidity2}
              onChange={(e) => setLiquidity2(e.target.value)}
              onWheel={e => e.target.blur()}
              className="bg-transparent flex-1   focus:outline-none h-8"
              placeholder="Enter Amount"
            />
            <button
              type="button"
              onClick={() => setShowTokenSelector2(true)}
              className="flex items-center ml-2 focus:outline-none rounded-full  hover:bg-white/5 border border-white/30 px-3 py-1"
            >
              <span className="mr-1 text-[13px]">{formatTokenDisplay(token2)}</span>
              <svg
                className="w-4 h-4  "
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Buy Fee Amount */}
        <div>
          <label className=" mb-2 text-start flex font-semibold text-[14px] text-gray-300 mt-8">
            Buy LP Fee Amount
            <div className="relative ml-2 group">
              <svg
                className="w-4 h-4 text-gray-400 cursor-pointer"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM9 7v2h2V7H9zm0 4v4h2v-4H9z" />
              </svg>
              <div className="absolute bottom-full left-1/2 transform  kanit-light font-[300] text-white -translate-x-1/2 mb-2 w-64 p-2 bg-[#0e1018] border border-white/15   text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                Fee distributed to LP providers as a flat USD fee (in ETH) 
              </div>
            </div>
          </label>
          <div className="w-full p-2 border-t border-b text-[15px]  border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="number"
              value={buyFeeAmount}
              onChange={(e) => setBuyFeeAmount(e.target.value)}
              onWheel={(e) => e.target.blur()}   // ① immediately defocus
              className="bg-transparent w-full   focus:outline-none h-8"
              placeholder="Enter buy fee amount"
            />
          </div>
        </div>

        {/* Sell Fee Amount */}
        <div>
          <label className="flex mb-2 text-[14px] text-start font-semibold text-gray-300">
            Sell LP Fee Amount
            
          </label>
          <div className="w-full p-2 border-t border-b text-[15px] border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="number"
              value={sellFeeAmount}
              onChange={(e) => setSellFeeAmount(e.target.value)}
              onWheel={(e) => e.target.blur()}   // ① immediately defocus
              className="bg-transparent w-full   focus:outline-none h-8"
              placeholder="Enter sell fee amount"
            />
          </div>
        </div>

        {/* Protocol Address */}
        <div>
          <label className="text-[14px] mb-3 text-start font-semibold text-gray-300 flex items-center mt-8">
            Protocol Address
            <div className="relative ml-2 group">
              <svg
                className="w-4 h-4 text-gray-400 cursor-pointer"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM9 7v2h2V7H9zm0 4v4h2v-4H9z" />
              </svg>
              <div className="absolute bottom-full left-1/2 transform kanit-light font-[300] text-white -translate-x-1/2 mb-2 w-64 p-2 bg-[#0e1018] border border-white/15   text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                Usually the creator address or the smart contract address which
                receives the protocol fee every swap
              </div>
            </div>
          </label>
          <div className="w-full px-2 py-1 text-[15px] border-t border-b border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="text"
              value={protocolAddress}
              onChange={(e) => setProtocolAddress(e.target.value)}
              className="bg-transparent w-full text-gray-400 focus:outline-none h-12"
              placeholder="Enter Protocol Address"
            />
          </div>
        </div>

        {/* Protocol Buy Fee */}
        <div>
          <label className="block text-[14px] flex mb-2 text-start font-semibold text-gray-300">
            Protocol Buy Fee
            <div className="relative ml-2 group">
              <svg
                className="w-4 h-4 text-gray-400 cursor-pointer"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM9 7v2h2V7H9zm0 4v4h2v-4H9z" />
              </svg>
              <div className="absolute bottom-full left-1/2 transform kanit-light font-[300] text-white -translate-x-1/2 mb-2 w-64 p-2 bg-[#0e1018] border border-white/15 text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                This fee is distributed to the protocol address as a flat USD (in ETH) amount when a buy occurs.
              </div>
            </div>
          </label>
          <div className="w-full p-2 border-t border-b text-[15px] border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="number"
              value={protocolBuyFee}
              onChange={(e) => setProtocolBuyFee(e.target.value)}
              onWheel={(e) => e.target.blur()}   // ① immediately defocus
              className="bg-transparent w-full   focus:outline-none h-8"
              placeholder="Enter protocol buy fee"
            />
          </div>
        </div>

        {/* Protocol Sell Fee */}
        <div>
          <label className="block text-[14px] mb-2 text-start font-semibold text-gray-300">
            Protocol Sell Fee
          </label>
          <div className="w-full p-2 border-t border-b text-[15px] border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none">
            <input
              type="number"
              value={protocolSellFee}
              onChange={(e) => setProtocolSellFee(e.target.value)}
              onWheel={(e) => e.target.blur()}   // ① immediately defocus
              className="bg-transparent w-full   focus:outline-none h-8"
              placeholder="Enter protocol sell fee"
            />
          </div>
        </div>

        {/* Transaction Path Indicator */}
        {signer && (
          <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-white/80 text-sm font-medium">Transaction Path</span>
            </div>
            <div className="space-y-1">
              {transactionPath.map((step, index) => (
                <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                  <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                  <span>{step}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Launch Button */}
        {signer !== null && 
        <button
          type="submit"
          className="w-full text-white bg-white/5 hover:bg-white/10 border  border-white/10 py-2 rounded-md font-semibold  transition duration-300"
        >
          Launch
        </button> 
      
        }

      </form>
      {signer === null &&
          <button
          //onClick={initializeProvider}
          className="w-full text-white bg-white/5 hover:bg-white/10 border  border-white/10 py-2 rounded-md font-semibold  transition duration-300"
        >
          Connect
        </button>      
      }
 
  
      {showTokenSelector2 && (
        <TokenSelectorPopup
          onClose={() => setShowTokenSelector2(false)}
          onSelect={(token) => setToken2(token)}
        />
      )}
    </div>
  );
};

export default LaunchForm;
